export default async function GetFilteredUnitPerformanceApi(
  performanceCycle,
  name,
  organizationLevel,
  page,
  positionId,
  LIMIT_PER_PAGE
) {
  let res = "";
  try {
    const body = {
      performanceCycle: performanceCycle,
      name: name || "",
      organizationLevel: organizationLevel || "",
      positionId: positionId,
      page: page,
      limit: LIMIT_PER_PAGE,
    };
    const token = "Bearer " + localStorage.getItem("authToken");
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: token,
      },
      body: JSON.stringify(body),
    };
    await fetch(
      `${process.env.REACT_APP_API_URL}v1/units/filtered-unit-performance-table`,
      requestOptions
    )
      .then((response) => response.json())
      .then((response) => {
        res = response;
      })
      .catch((error) => {
        console.error("Error getting units performance filter: ", error);
        res = error;
      });
  } catch (error) {
    console.error(error);
    res = error;
  }

  return res;
}
